import styled from "styled-components";

export const ChangeColor = styled.span<{ color: string }>`
  color: ${(props) => props.color};
`;
